import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import DailyPicks from './components/DailyPicks';
import TestimonialSection from './components/TestimonialSection';
import DataShowcase from './components/DataShowcase';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import { faqs } from '@/mocks/data';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <DailyPicks />
        <DataShowcase />
        <TestimonialSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "51黑料网官网 - 黑料吃瓜第一站",
          "description": "51黑料网官网是黑料吃瓜第一站，整合全网独家网红明星爆料与每日大赛正能量资源，24小时黑料不打烊",
          "url": "https://www.51heiliaobaike.com/",
          "isPartOf": {
            "@type": "WebSite",
            "name": "51黑料网",
            "url": "https://www.51heiliaobaike.com/"
          }
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })
      }} />
    </>
  );
}